import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export enum DepartureTime {
  T0 = '00:00-06:00',
  T6 = '06:00-09:00',
  T9 = '09:00-12:00',
  T12 = '12:00-15:00',
  T15 = '15:00-18:00',
  T18 = '18:00-21:00',
  T21 = '21:00-00:00',
}

const departureTimeMap = [
  {
    groupTitle: '새벽',
    times: [{ time: DepartureTime.T0, className: '1hf', clickCode: 'tmX06' }],
  },
  {
    groupTitle: '오전',
    times: [
      { time: DepartureTime.T6, className: '3qt', clickCode: 'tmX09' },
      { time: DepartureTime.T9, className: '2qt', clickCode: 'tmX12' },
    ],
  },
  {
    groupTitle: '오후',
    times: [
      { time: DepartureTime.T12, className: '1qt', clickCode: 'tmX15' },
      { time: DepartureTime.T15, className: '4qt', clickCode: 'tmX18' },
    ],
  },
  {
    groupTitle: '밤',
    times: [
      { time: DepartureTime.T18, className: '3qt', clickCode: 'tmX21' },
      { time: DepartureTime.T21, className: '2qt', clickCode: 'tmX24' },
    ],
  },
];

interface IProps {
  areaCode: string;
  selected: Set<DepartureTime>;
  seq: string;
  title: string;
  onChange: (key?: any) => void;
  onSelectAll: () => void;
}

export default function DepartureTimeFilter({
  areaCode,
  selected,
  seq,
  title,
  onChange,
  onSelectAll,
}: IProps) {
  const handleClick = (key: DepartureTime) => () => onChange(key);

  return (
    <div className={cx('DepartureTimeFilter')}>
      <dl className={cx('group')} key="timeGroup_all">
        <dt className={cx('title')}>종일</dt>
        <dd className={cx('times')}>
          <button
            type="button"
            aria-checked={selected?.size === 0}
            className={cx('time')}
            role="checkbox"
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.tm${seq}all`}
            onClick={onSelectAll}
          >
            {title} 전체
          </button>
        </dd>
      </dl>
      {departureTimeMap.map(({ groupTitle, times }, i) => (
        <dl className={cx('group')} key={`timeGroup_${i}`}>
          <dt className={cx('title')}>{groupTitle}</dt>
          <dd className={cx('times')}>
            {times.map(({ time, className, clickCode }, j) => (
              <button
                type="button"
                key={`times_${j}`}
                aria-checked={selected?.has(time)}
                className={cx('time', `as_${className}`)}
                role="checkbox"
                data-event-nlog="click"
                data-event-area-code={`${areaCode}.${clickCode.replace('X', seq)}`}
                onClick={handleClick(time)}
              >
                {time}
              </button>
            ))}
          </dd>
        </dl>
      ))}
    </div>
  );
}
